import { useContext, useMemo } from "react";
import { ConfigContext } from "../../../contexts/ConfigContext";
import { ProcessContext } from "../../../contexts/ProcessContext";
import { docIdTypes } from "../../../components/modules/kyc/shared/config";
import { SPANISH_NATIONALITY } from "../../../components/modules/kyc/KycManual/constants/SpanishNationality";
import { NationalityMap } from "./maps/nationalityMap";

export const useNationalities = () => {
  const {
    state: { language },
  } = useContext(ConfigContext);

  const {
    state: { documentType },
  } = useContext(ProcessContext);

  const nationalities = useMemo(() => {
    const nationalities = NationalityMap.byLanguage(language);
    if (documentType !== docIdTypes.PASSPORT) return nationalities;
    return nationalities.filter(
      (nationality) => nationality.value !== SPANISH_NATIONALITY
    );
  }, [documentType]);

  return {
    nationalities,
  };
};
